/** @jsxImportSource @emotion/react */
import * as React from "react";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { OrderListItem } from "../../model/OrderListSuccessResponse";
import { routes } from "../../../../appRoutingHelpers";
// import { useTranslation } from "react-i18next";
import { TableCellLink } from "../../../../components/table-components/TableCellLink";
import { StyledText } from "../../../../assets/typography/typography";
import { colors } from "../../../../components/colors";
import { TableRow } from "../../../../components/table-components/TableRow";
import { InLineLabel } from "../../../../components/Label";
import {
  formatDateWithTime,
  formatMoneyAmount,
  formatOrderState,
  formatOrderStateBgColor,
  formatOrderStateTextColor,
  formatOrderType,
} from "../../../../util";
import { css } from "@emotion/react";

interface Props {
  order: OrderListItem;
}

const truncateWrapper = css`
  overflow: hidden;
  width: 150px;
`;

const truncateText = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const OrderListRow: React.FC<Props> = ({ order }) => {
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);

  // https://docs.google.com/spreadsheets/d/1-Sty6cgaqxO-4C2SqUiuSd6aZb2v7PBmZeRdrQc1dtU/edit#gid=0
  const orderType = formatOrderType(order.deliveryType);
  const labelBackgroundColor = formatOrderStateBgColor(order.state);
  const labelTextColor = formatOrderStateTextColor(order.state);
  const labelText = formatOrderState(order.state, order.deliveryType);
  const href = routes.orderShow(organization, order.id);

  return (
    <TableRow>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {order.displayId}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href} css={truncateWrapper}>
        <StyledText
          css={truncateText}
          className="bodyTextRegular mb-0"
          color={colors.textPrimary}
        >
          {order?.customer.fullname}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href} css={truncateWrapper}>
        <StyledText
          css={truncateText}
          className="bodyTextRegular mb-0"
          color={colors.textPrimary}
        >
          {order.shop.name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {orderType.orderType}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {order?.paidAt
            ? formatDateWithTime(order.paidAt)
            : "Order not placed"}
        </StyledText>
      </TableCellLink>
      <TableCellLink
        href={href}
        style={{ whiteSpace: "nowrap", textDecoration: "none" }}
      >
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {order?.preOrderFor ? formatDateWithTime(order?.preOrderFor) : "ASAP"}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <InLineLabel
          backgroundColor={labelBackgroundColor}
          color={labelTextColor}
        >
          {labelText}
        </InLineLabel>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {formatMoneyAmount(order.total.amount, order.total.currency)}
        </StyledText>
      </TableCellLink>
    </TableRow>
  );
};

export default OrderListRow;
